<template>
  <div class="base-phone-count-line">
    <span v-if="$scopedSlots.count" class="base-phone-count-line__count"><slot name="count" /></span>
    <div class="base-phone-count-line__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
// A list's count line on phones (docs/page-layout.md): the count on the left, the list's buttons on
// the right. BasePhoneTable draws one above its rows; a page whose list isn't a table draws its own.
export default {
  name: 'BasePhoneCountLine',
};
</script>

<style lang="scss">
// 36px tall, 12px above the list; buttons that don't fit beside the count go on a line of their own
// under it.
.base-phone-count-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 4px;
  min-height: 36px;
  margin-bottom: 12px;

  &__count {
    white-space: nowrap;
    padding: 4px 12px;
    font-size: $font-size-small;
    color: $color-neutral;
    text-transform: uppercase;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
}
</style>
